import { __makeTemplateObject } from "tslib";
import React from 'react';
import { css } from 'emotion';
import { useStyles } from '../../themes';
var EmptySearchResult = function (_a) {
    var children = _a.children;
    var styles = useStyles(getStyles);
    return React.createElement("div", { className: styles.container }, children);
};
var getStyles = function (theme) {
    return {
        container: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-left: 3px solid ", ";\n      background-color: ", ";\n      padding: ", ";\n      min-width: 350px;\n      border-radius: ", ";\n      margin-bottom: ", ";\n    "], ["\n      border-left: 3px solid ", ";\n      background-color: ", ";\n      padding: ", ";\n      min-width: 350px;\n      border-radius: ", ";\n      margin-bottom: ", ";\n    "])), theme.palette.blue80, theme.colors.bg2, theme.spacing.d, theme.border.radius.md, theme.spacing.xl),
    };
};
export { EmptySearchResult };
var templateObject_1;
//# sourceMappingURL=EmptySearchResult.js.map